<template>
  <div class="header" :class="{'mobile-menu-open':menuOpen}">
    <el-alert title="" type="error" class="alert-warn" :closable="false" center>
      <template #title>
        <a><span class="alert-chip"><img src="@/assets/images/ico-warn.svg" alt=""><span>防詐提醒</span></span>
          遇到可疑來電，請保持警覺：勿操作ATM、勿透露個資、勿回撥陌生電話。如有疑慮，請立即掛斷並撥打165防詐騙專線查證。</a>
      </template>
    </el-alert>
    <div class="container nav-container">
      <div class="nav-logo">
        <router-link to="/"><img src="@/assets/images/logo.svg" alt=""></router-link>
      </div>
      <div class="nav-box" :class="{'pre-show':menuOpen}">
        <ul class="nav-ul">
          <li @click="showMenu(1)">
            <router-link to="/order" :style="{color:route.path == '/order'?'rgba(0, 151, 224, 1)':'#3D4043'}">訂單管理
            </router-link>
          </li>
          <li @click="showMenu(1)">
            <router-link to="/DMdoload" :style="{color:route.path == '/DMdoload'?'rgba(0, 151, 224, 1)':'#3D4043'}">
              DM下載
            </router-link>
          </li>
<!--          <li @click="showMenu(1)">-->
<!--            <router-link to="/business" :style="{color:route.path == '/business'?'rgba(0, 151, 224, 1)':'#3D4043'}">-->
<!--              業務窗口-->
<!--            </router-link>-->
<!--          </li>-->
          <li><a href="{javascript:void(0);" @click.prevent="toggleSubmenu(1)"
                 :style="{color:['/personal','/commission'].some(p=>route.path.startsWith(p))?'rgba(0, 151, 224, 1)':'#3D4043'}">我的帳戶</a>
            <transition name="slide">
              <div class="submenu">
                <ul>
                  <li @click="showMenu(1)">
                    <router-link to="/personal"
                                 :style="{color:route.path == '/personal'?'rgba(0, 151, 224, 1)':'#3D4043'}">個人資料
                    </router-link>
                  </li>
                  <li @click="showMenu(1)">
                    <router-link to="/personal/changeRequest"
                                 :style="{color:route.path == '/personal/changeRequest'?'rgba(0, 151, 224, 1)':'#3D4043'}">
                      申請變更
                    </router-link>
                  </li>
                  <li @click="showMenu(1)" v-if="userInfo?.frontendRole == 1">
                    <router-link to="/personal/user"
                                 :style="{color:route.path == '/personal/user'?'rgba(0, 151, 224, 1)':'#3D4043'}">公司會員管理
                    </router-link>
                  </li>
                  <li @click="showMenu(1)">
                    <router-link to="/commission"
                                 :style="{color:route.path.startsWith('/commission')?'rgba(0, 151, 224, 1)':'#3D4043'}">佣金結算
                    </router-link>
                  </li>
                </ul>
              </div>
            </transition>
          </li>
          <li @click="showMenu(1)">
            <router-link to="/demand"
                         :style="{color:route.path.startsWith('/demand')?'rgba(0, 151, 224, 1)':'#3D4043'}">我的需求追蹤
            </router-link>
          </li>
          <li></li>
        </ul>
      </div>
      <div class="nav-user">
        <img src="@/assets/images/ico-user.svg" alt="">
        <span>嗨！{{userInfo?.name}}</span>
        <el-button @click="loginOut">登出</el-button>
        <div class="burger" @click="showMenu">
          <div class="burger-menu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="wrap-nav-mask" @click="showMenu"></div>
      </div>
    </div>

  </div>
</template>
<script setup lang="ts">
import {getCurrentInstance, onMounted, ref, watch,} from "vue";
import {useRoute, useRouter} from "vue-router";
import {getUserInfo} from '../utils/auth'
import { removeToken,removeUserInfo } from "@/utils/auth"
const {proxy} = getCurrentInstance()
const route = useRoute();
const router = useRouter();
const menuOpen = ref(false)
const activeIndex = ref(null)
const toggleSubmenu = (index) => {
  activeIndex.value = activeIndex.value === index ? null : index
}

function showMenu(i) {
  menuOpen.value = i == 1 ? false : !menuOpen.value
}

function loginOut() {
  proxy.$post('/api/member/logout',).then(res => {
   removeToken()
    removeUserInfo()
    router.push('/login')
  }).catch((e) => {
  })

}

// 監聽移動端是否展開
watch(menuOpen, (val) => {
  if (val) {
    document.body.classList.add('hide')
  } else {
    document.body.classList.remove('hide')
  }
})
const userInfo = ref({})
onMounted(() => {
  userInfo.value = JSON.parse(getUserInfo('userInfo'))
})
</script>
<style lang="scss" scoped>
//.Header {
//  text-align: center;
//  margin: 20px 0;
//  font-weight: 700;
//  font-size: 20px;
//}
.nav-container {
  display: flex;
}

.nav-logo {
  align-self: center;
}

.nav-logo a, .nav-logo img {
  display: block;
}

.nav-box {
  display: flex;
  align-self: center;
  flex-grow: 1;
  padding-right: clamp(100px, 9.166vw, 176px);
}

.nav-ul {
  display: flex;
  justify-content: space-around;
  flex-grow: 1;
}

.nav-ul > li {
  display: flex;
  gap: 20px;
}

.nav-ul > li a {
  color: #3D4043;
  font-size: 17px;
  font-weight: 400;
}

.nav-ul > li a:hover {
  color: rgba(0, 151, 224, 1) !important;
}

.nav-user {
  display: flex;
  margin-left: auto;
  align-items: center;
  gap: 14px;
  font-size: 17px;
  font-weight: 400;
}

//.header{position: sticky;top: 0;background: #FFFFFF;z-index: 6;}
.header .nav-container {
  padding-top: 18px;
  padding-bottom: 18px
}

@media (max-width: 980px) {
  .header {
    --height: 48px;
  }
  .nav-container {
    height: var(--height)
  }
  .nav-logo {
    height: 24px;
    align-self: center;
  }
  .nav-logo a {
    display: block;
    height: 100%;
  }
  .nav-logo img {
    height: 24px;
  }
  .nav-user {
    gap: 5px;
    font-size: 12px;
  }
  .nav-box {

  }
  .burger {
    z-index: 8;
  }
  .nav-box {
    position: fixed;
    width: 180px;
    overflow-x: hidden;
    top: 48px;
    bottom: 0;
    left: 0;
    height: 100vh;
    background: linear-gradient(180deg, #D6EDFF -31.57%, #FFFFFF 67.28%);
    z-index: 8;
    transform: translateX(-320px);
    transition: transform .25s;
  }

  .nav-box.pre-show {
    visibility: visible;
    transform: translateX(0);
  }
  .nav-ul {
    padding-top: var(--height);
    display: block;
    padding-left: 16px;
    padding-right: 16px;
  }
  .nav-box {
    padding-right: 0;
  }
  .nav-ul li {
    margin-bottom: 20px;
  }
  .header .el-alert + .container .nav-box {

  }
}
</style>

